exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail_multi_part_text[data-v-11c9b19d]{padding:.3125rem 1.0625rem 1.5625rem}.detail_multi_part_text .c-toggler[data-v-11c9b19d]{margin:5rem 0 2rem 0}.detail_multi_part_text .c-toggler[data-v-11c9b19d]:first-child{margin:0 0 2rem 0}@media screen and (min-width:48em){.detail_multi_part_text[data-v-11c9b19d]{padding:1.875rem 7.375rem .9375rem}}@media screen and (min-width:64em){.detail_multi_part_text[data-v-11c9b19d]{padding:1.875rem 1.875rem .9375rem}}@media screen and (min-width:75em){.detail_multi_part_text[data-v-11c9b19d]{padding:3.125rem 0 0}}", ""]);

// exports
